export const headerConfig = {
  headerTitle: 'Rejected Applications',
  headerDescription: 'List of Rejected Applications',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
